<template>
    <div class="page-container">
        <div class="toolbar">
            <el-form :inline="true">
                <el-form-item>
                    <el-input v-model="searchKehu" placeholder="请输入客户标识" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="loadData">查询</el-button>
                    <el-button type="success" @click="handleAdd">添加</el-button>
                    <el-button type="warning" @click="batchUpdate" :disabled="selection.length === 0">
                        批量修改({{ selection.length }})
                    </el-button>
                    <el-button type="info" @click="exportExcel" :disabled="selection.length === 0">
                        导出选中
                    </el-button>
                    <el-upload action="" :auto-upload="false" :on-change="handleExcelImport" accept=".xlsx,.xls"
                        :show-file-list="false" style="display: inline-block; margin-left: 10px;">
                        <el-button type="primary">导入Excel</el-button>
                    </el-upload>
                    <el-button type="text" @click="downloadTemplate">下载模板</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table :data="tableData" style="width: 100%; margin-top: 20px" v-loading="loading" border
            @selection-change="handleSelectionChange">

            <el-table-column type="selection" width="55"></el-table-column>

            <el-table-column prop="kehu" label="客户标识" />
            <el-table-column prop="uptype" label="上报类型">
                <template slot-scope="scope">
                    {{ typeMap[scope.row.uptype] || '未知' }}
                </template>
            </el-table-column>
            <el-table-column prop="reportpercent" label="设置的概率(%)" />
            <el-table-column prop="totalData" label="数据总数" />
            <el-table-column label="上报率">
                <template slot-scope="scope">
                    {{ calcRate(scope.row.reportedData, scope.row.totalData) }}%
                </template>
            </el-table-column>

            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button size="mini" type="primary" plain @click="generateHandle(scope.row)">生成点击链接</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="批量修改设置" :visible.sync="batchDialogVisible" width="30%">
            <el-form label-width="100px">
                <el-form-item label="上报类型">
                    <el-select v-model="batchForm.uptype" placeholder="请选择上报类型">
                        <el-option label="激活" value="0" />
                        <el-option label="首次拉活" value="8" />
                    </el-select>
                </el-form-item>
                <el-form-item label="设置概率(%)">
                    <el-input-number v-model="batchForm.reportpercent" :min="0" :max="100"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="batchDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmBatchUpdate">确认</el-button>
            </span>
        </el-dialog>

       
        <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="700px">
            <el-form :model="form" label-width="100px">
                <el-form-item label="上报类型">
                    <el-select v-model="form.uptype" placeholder="请选择上报类型">
                        <el-option label="激活" value="0" />
                        <el-option label="首次拉活" value="8" />
                    </el-select>
                </el-form-item>
                <el-form-item label="客户标识">
                    <el-input v-model="form.kehu" :disabled="!!form.id" />
                </el-form-item>
                <el-form-item label="设置概率(%)">
                    <el-input v-model="form.reportpercent" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm">确认</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="generateDialog" width="700px">
            <el-form :model="form2">
                <el-form-item>
                    <div style="width: 100%;">
                        <el-input v-model="form2.url" placeholder="生成的链接" clearable
                            style="width: 80%; display: inline-block; vertical-align: middle;" />
                        <el-button type="primary" @click="fuzhicopy"
                            style="display: inline-block; vertical-align: middle; margin-left: 10px;">
                            复制
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
    data() {
        return {
            generateDialog: false,
            typeMap: {
                0: '激活',
                8: '首次拉活'
            },
            searchKehu: '',
            tableData: [],
            loading: false,
            dialogVisible: false,
            dialogTitle: '添加客户',
            form: { id: null, kehu: '', uptype: '', reportpercent: '' },
            form2: { url: '' },
            userId: null,
            selection: [], 
            batchDialogVisible: false, 
            batchForm: { 
                uptype: '',
                reportpercent: 0
            },
            clickLinks: {} 
        }
    },
    created() {
        this.userId = this.$route.query.userId
        if (!this.userId) {
            this.$message.warning('您得先登录')
            setTimeout(() => {
                window.location.href = 'https://control.zjwec.cn/page/end/login.html'
            }, 1500)
        }
        this.loadData()
    },
    methods: {
        handleSelectionChange(val) {
            this.selection = val
        },

        batchUpdate() {
            if (this.selection.length === 0) {
                this.$message.warning('请至少选择一条记录')
                return
            }
            this.batchDialogVisible = true
        },

        async confirmBatchUpdate() {
            const params = this.selection.map(item => ({
                id: item.id,
                kehu: item.kehu,
                uptype: this.batchForm.uptype || item.uptype,
                reportpercent: this.batchForm.reportpercent || item.reportpercent,
                userid: this.userId
            }))

            try {
                const res = await axios.post('https://control.zjwec.cn/qtt/clickControl/batchUpdate', params)
                if (res.data.code == 0) {
                    this.$message.success('批量修改成功')
                    this.loadData()
                } else {
                    this.$message.error(res.data.message || '批量修改失败')
                }
            } catch (error) {
                this.$message.error('批量修改请求失败')
            } finally {
                this.batchDialogVisible = false
            }
        },

        exportExcel() {
            if (this.selection.length === 0) {
                this.$message.warning('请至少选择一条记录')
                return
            }

            const headerMap = {
                'kehu': '客户标识',
                'uptype': '上报类型',
                'reportpercent': '设置概率(%)',
                'totalData': '数据总数',
                'reportRate': '上报率',
                'clickLink': '点击链接'
            }


            const data = this.selection.map(item => ({
                kehu: item.kehu,
                uptype: this.typeMap[item.uptype] || '未知',
                reportpercent: item.reportpercent,
                totalData: item.totalData,
                reportRate: this.calcRate(item.reportedData, item.totalData) + '%',
                clickLink: this.clickLinks[item.id] || this.generateLink(item)
            }))

            const filteredData = data.map(item => {
                const newItem = {}
                Object.keys(headerMap).forEach(key => {
                    newItem[headerMap[key]] = item[key]
                })
                return newItem
            })

            this.exportToExcel({
                data: filteredData,
                filename: `客户数据_${new Date().toLocaleDateString()}`
            })
        },

        exportToExcel({ data, filename }) {
            const ws = XLSX.utils.json_to_sheet(data)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
            XLSX.writeFile(wb, `${filename}.xlsx`)
        },

        downloadTemplate() {
            const templateData = [
                {
                    '客户标识': '示例客户1',
                    '上报类型': '激活',
                    '设置概率(%)': '50'
                },
                {
                    '客户标识': '示例客户2',
                    '上报类型': '首次拉活',
                    '设置概率(%)': '30'
                }
            ]
            this.exportToExcel({
                header: ['客户标识', '上报类型', '设置概率(%)'],
                data: templateData,
                filename: '客户数据导入模板'
            })
        },
        handleExcelImport(file) {
            const reader = new FileReader()
            reader.onload = async (e) => {
                try {
                    const data = new Uint8Array(e.target.result)
                    const workbook = XLSX.read(data, { type: 'array' })
                    const firstSheet = workbook.Sheets[workbook.SheetNames[0]]
                    const jsonData = XLSX.utils.sheet_to_json(firstSheet)

                    
                    const importData = jsonData.map(item => {
                        const typeValue = item['上报类型'] === '首次拉活' ? '8' : '0'
                        return {
                            kehu: item['客户标识'],
                            uptype: typeValue,
                            reportpercent: item['设置概率(%)'],
                            userid: this.userId
                        }
                    })

                    
                    const res = await axios.post('https://control.zjwec.cn/qtt/clickControl/batchInsert', importData)
                    if (res.data.code == 0) {
                        this.$message.success(`成功导入${importData.length}条数据`)
                        this.loadData()
                    } else {
                        this.$message.error(res.data.message || '导入失败')
                    }
                } catch (error) {
                    this.$message.error('Excel解析失败')
                    console.error(error)
                }
            }
            reader.readAsArrayBuffer(file.raw)
        },

        generateLink(row) {
            return `https://control.zjwec.cn/qtt/clickData/saveClickData?cid=__CID__&os=__OS__&imeimd5=__IMEIMD5__&idfamd5=__IDFAMD5__&ts=__TS__&tsms=__TSMS__&callbackurl=__CALLBACK_URL__&unit=__UNIT__&plan=__PLAN__&uid=__UID__&ip=__IP__&oaid=__OAID__&oaidmd5=__OAIDMD5__&deeplink=__DP_LINK__&productname=__PRODUCT_NAME__&kehu=${row.kehu}&uptype=${row.uptype}`
        },

        async fuzhicopy() {
            try {
                await navigator.clipboard.writeText(this.form2.url);
                this.$message.success('复制成功');
            } catch (err) {
                console.error('复制失败', err);
                this.$message.error('复制失败，请手动复制');
            }
        },
        generateHandle(row) {
            this.$message.success('生成成功');
            this.generateDialog = true
            this.form2.url = this.generateLink(row)
            this.$set(this.clickLinks, row.id, this.form2.url)
        },
        async loadData() {
            this.loading = true
            try {
                const ctrlRes = await axios.get('https://control.zjwec.cn/qtt/clickControl/getAllControls', {
                    params: { userid: this.userId }
                })
                this.tableData = ctrlRes.data.data || []
            } catch (err) {
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        calcRate(reported, total) {
            return total ? ((reported / total) * 100).toFixed(2) : '0.00'
        },
        handleAdd() {
            this.dialogTitle = '添加客户'
            this.form = { id: null, kehu: '', uptype: '', reportpercent: '' }
            this.dialogVisible = true
        },
        handleEdit(row) {
            this.dialogTitle = '编辑客户'
            this.form = {
                id: row.id,
                kehu: row.kehu,
                uptype: row.uptype,
                reportpercent: row.reportpercent,
            }
            this.dialogVisible = true
        },
        async handleDelete(row) {
            this.$confirm(`确定删除选中的记录吗？`, '删除', { type: 'warning' })
                .then(async () => {
                    const res = await axios.delete(`https://control.zjwec.cn/qtt/clickControl/${row.id}`)
                    if (res.data.code == 0) {
                        this.$message.success('删除成功');
                        this.loadData()
                    } else {
                        this.$message.error('删除失败');
                    }
                });
        },
        async submitForm() {
            const api = this.form.id ? 'setControl' : 'setControl'
            const res = await axios.post(`https://control.zjwec.cn/qtt/clickControl/${api}`,
                { ...this.form, userid: this.userId })

            if (res.data.code == 0) {
                this.$message.success(this.form.id ? '更新成功' : '添加成功');
                if (this.form.id) {
                    await axios.get('https://control.zjwec.cn/qtt/clickData/deleteByKeHu', {
                        params: { kehu: this.form.kehu }
                    })
                }
                this.loadData()
            } else {
                this.$message.error(this.form.id ? '更新失败' : '添加失败');
            }
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped>
.page-container {
    padding: 20px;
}

.toolbar {
    margin-bottom: 20px;
}

.dialog-footer {
    text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/components/huawei/clickControl.vue